import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=0bce394a&scoped=true"
import script from "./TimelineItem.ts?vue&type=script&lang=ts&external"
export * from "./TimelineItem.ts?vue&type=script&lang=ts&external"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&id=0bce394a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce394a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bce394a')) {
      api.createRecord('0bce394a', component.options)
    } else {
      api.reload('0bce394a', component.options)
    }
    module.hot.accept("./TimelineItem.vue?vue&type=template&id=0bce394a&scoped=true", function () {
      api.rerender('0bce394a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Versioning/components/TimelineItem/TimelineItem.vue"
export default component.exports